import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromReducer from '@app/store/reducers/static-lists.reducer';

export const staticListsState = createFeatureSelector<fromReducer.StaticListsState>('staticLists');

export const selectStaticLists = createSelector( staticListsState, (state) => state );
